import MobileView from "./view/mobile";
import DesktopView from "./view/desktop";
import { isMobile, isTablet } from "react-device-detect";

export default isMobile && !isTablet ? MobileView : DesktopView;
